import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { of } from 'rxjs';
import { JobService } from '../../service/job.service';
import { PatrolSheetService } from '../../service/patrol-sheet.service';
import { QuestionService } from '../../service/question.service';
import { AuthenticationService } from '../../service/system/authentication.service';
import { QuestionBase } from '../controls/question-base';

@Component({
  selector: 'app-patrol-control-preview',
  templateUrl: './patrol-control-preview.component.html',
  styleUrls: ['./patrol-control-preview.component.less']
})
export class PatrolControlPreviewComponent implements OnInit , OnChanges {

  @Input() controls: any[] = [];
  @Input() formDisabled: false | undefined;
  @Input() groupId: number | undefined;
  @Input() jobId: number | undefined;
  @Input() epNo: number | undefined;
  questions: any[] = [];
  form!: FormGroup;
  selectdEquipment: any;
  list: any [] = [];
  @Input() equipment: any = {};
  constructor(
    public qs: QuestionService,
    public modalService: NzModalService,
    public patrolSheetService: PatrolSheetService,
    public authService: AuthenticationService,
    public message: NzMessageService,
    public jobService: JobService
    ) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['controls'] != null) {
      this.initQuestions();
      await this.initRepairJobs();
    }
    // 避开父组件对于变量的初始化赋值
    // if (changes.equipment && !changes.equipment.firstChange){
    //   await this.initRepairJobs();
    // }
  }
  async ngOnInit() {
    this.initQuestions();
  }
  async initRepairJobs(){
    if (this.equipment && this.equipment.repairJobId){
      // 拿到工单id集合请求工单集合
      const res = await this.jobService.getRepairJobsByIds(this.equipment.repairJobId.toString());
      const resultList: any[] = [];
      res.map((item: any, index: any, array: any) => {
        switch (item.status){
          case '1':
            res[index].status = '未处理';
            break;
          case '2':
            res[index].status = '已派工';
            break;
          case '3':
            res[index].status = '处理中';
            break;
          case '4':
            res[index].status = '待审核';
            break;
          case '5':
            res[index].status = '已完成';
            break;
          default:
        }
        resultList.push(array[index]);
      });
      this.list = resultList;
    }else{
      this.list = [];
    }
  }
  initQuestions(){
    this.questions = [];
    this.controls.forEach((control: any) => {
      this.questions.push(this.qs.getControl(control.ptctNo, {
        key: control.key,
        value: control.value,
        label: control.label,
        order: control.order,
        row: control.row,
        column: control.column,
        options: control.options,
        placeholder: control.placeholder,
        unit: control.unit,
        format: control.format,
      }, 1));
    }
    );
    of(this.questions.sort((a, b) => a.order - b.order));
    this.form = this.qs.toFormGroup(this.questions as QuestionBase<string>[]);
    if (this.formDisabled){
      // tslint:disable-next-line:forin
      for (const key in this.form.controls) {
        this.form.controls[key].disable();
      }
    }
  }
  public submitForm($event: any){
    this.modalService.confirm({
      nzTitle: '您确定要提交表单吗？',
      nzContent: '当点击确定时，表单将被提交！',
      nzOkDanger: true,
      nzOnOk: () => {
        this.patrolSheetService.getPatrolSheetsByJobIdAndgroupId(this.jobId, this.groupId).subscribe((data) => {
          if (!this.isEmpty(data)){
            const patrolSheet: any = data[0];
            const sheetJson = JSON.parse(patrolSheet.sheetContent);
            const index = this.getIndex(sheetJson.equipments, this.epNo , 'epNo');
            if ( index !== -1){
              // tslint:disable-next-line:forin
              for (const control in this.form.controls) {
                console.log(control);     // 获取key值
                const controlIndex = this.getIndex(sheetJson.equipments[index].controls, control, 'key');
                if ( controlIndex !== -1 ){
                  sheetJson.equipments[index].controls[controlIndex].value = this.form.value[control];
                }
              }
            }
            patrolSheet.sheetContent = JSON.stringify(sheetJson);
            patrolSheet.updateBy = this.authService.getCurrentUserInfo().userId;
            this.patrolSheetService.updatePatrolSheet(patrolSheet).subscribe((result) => {
              if ( !this.isEmpty(result)){
                this.message.success('表单提交成功');
              }else{
                this.message.error('表单提交失败');
              }
            });
          }
        });
      }
    });
  }
  getIndex(ls: any[], filterStr: any, colum: any){
    for (let i = 0; i < ls.length; i++){
      if (ls[i][colum + ''] === filterStr){
        return i;
      }
    }
    return -1;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}


